export const lightGray = '#ececec';
export const gray = '#8f8f8f';
export const darkGray = '#414141';
export const boxiGreen = '#6aff53';
export const teal = '#53ffc9';
export const borderColor = 'rgba(197, 197, 197, 0.6)';

/* primary purple */
export const boxiPrimary = '#B93A76';
export const boxiPrimaryHover = '#d74287';
export const boxiPrimaryActive = '#B93A76';
export const boxiPrimarySublink = '#ec97bf';

/* primary purple */
// export const boxiPrimary = '#DD314F';
// export const boxiPrimaryHover = '#f55570';
// export const boxiPrimaryActive = '#DD314F';
// export const boxiPrimarySublink = '#ff97a8';

/* primary purple */
// export const boxiPrimary = '#F6503C';
// export const boxiPrimaryHover = '#fc6756';
// export const boxiPrimaryActive = '#F6503C';
// export const boxiPrimarySublink = '#f79c92';

/* yellow purple */
// export const boxiPrimary = '#FFCE60';
// export const boxiPrimaryHover = '#ffd779';
// export const boxiPrimaryActive = '#FFCE60';
// export const boxiPrimarySublink = '#ffe6ab';

export const boxiPurple = '#B93A76';
export const boxiRed = '#DD314F';
export const boxiOrange = '#F6503C';
export const boxiYellow = '#FFCE60';

export const aomRed = '#eb2128';
export const aomBlack = '#262626';